<header class="sidebar-header">
  <nv-logo (click)="navigateToHomepage()" [pointerOnHover]="true" class="logo" type="portal"></nv-logo>
  <!-- Held back until the user is there: the switcher reads currentUser once in ngOnInit, so one
       built from the empty slice keeps an empty dropdown for the life of the component. -->
  @if (currentUser) {
    <portal-switcher [currentUser]="currentUser" [selectedView]="selectedView" [label]="label"></portal-switcher>
  }
</header>
<div class="side-content-wrap">
  <nv-sidebar-list
    [listData]="topSectionSidebarOptions"
    [selectedKey]="selectedSidebarKey"
    (sidebarListItemSelect)="updateSelectedItem(topSectionSidebarOptions, { selectedItemKey: $event })"
  ></nv-sidebar-list>
  <nv-sidebar-list
    [listData]="middleSectionSidebarOptions"
    [selectedKey]="selectedSidebarKey"
    (sidebarListItemSelect)="updateSelectedItem(middleSectionSidebarOptions, { selectedItemKey: $event })"
  ></nv-sidebar-list>
</div>
<iframe id="logout-frame" class="hide"></iframe>
